import { RetiredService } from './retired.service';
import { RetirementDetails } from './../../../shared/models/retirement-details';
import { AcepSSOService, CommonOperationsService, GlobalDataOpsService, GlobalDomOpsService } from '@acepteam/globalspack';
import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { DataService, DomService, HelperService, LoggerService } from 'src/app/core/services';
import { MemberAppDataService, MemberAppDomService } from '../../services';
import { AddressComponent } from '../_common/address/address.component';
import { getChapterInfo_From_AccountProducts } from '../../helpers/mapper';
declare var moment: any;

@Component({
  selector: 'app-retired',
  templateUrl: './retired.component.html',
  styleUrls: ['./retired.component.scss']
})

export class RetiredComponent implements OnInit {

  isUnauthorized: boolean = false;
  headerText: string;
  retirementForm: FormGroup;
  ret: RetirementDetails;
  formSubmitted: boolean = false;
  isInternational: boolean = false;
  maxRetirementDate: any = new Date();
  chapters: any = [];
  get attest() {
    return this.retirementForm.get("attest");
  }

  get chapter() {
    return this.retirementForm.get("chapter");
  }

  get customerAddress(): FormGroup | any {
    return this.retirementForm.get("customerAddress");
  }


  constructor(
    private globalDataOpsService: GlobalDataOpsService,
    private globalDomOpsService: GlobalDomOpsService,
    private commonOpsService: CommonOperationsService,
    private ssoService: AcepSSOService,
    private dataService: DataService,
    private domService: DomService,
    private helperService: HelperService,
    private memberAppDataService: MemberAppDataService,
    private memberAppDomService: MemberAppDomService,
    private retiredService: RetiredService,

    private loggerService: LoggerService,
    private fb: FormBuilder
  ) { }

  ngOnInit(): void {

    let m = this.commonOpsService.DeepCopyObject(this.memberAppDataService.memberAppData);

    this.isUnauthorized = (m.profile.membership?.ExpirationDate == null) ||
      (moment(m.profile.membership?.ExpirationDate) < moment());
    //get content snippet    
    this.headerText = this.memberAppDataService.getContentSnippet(
      `MEMBERAPPLICATION_RETIREMENT`
    );



    this.chapters = m.chapterDetails.chapters;


    this.ret = {
      acepId: this.ssoService.acepid,
      formalName: this.ssoService.context.user.FormalName,
      expirationDate: moment(m.profile.membership.ExpirationDate).format('MM/DD/YYYY'),
      retirementDate: moment().format('MM/DD/YYYY'),
      customerAddress: m.personalInfo.customerAddress,
      chapter: m.chapterDetails.chapters.filter(a => a.isPrimary)[0].code
    }

    this.isInternational = this.ret.customerAddress.address.country != 'US';



    this.retirementForm = this.fb.group({
      acepId: [this.ret.acepId],
      formalName: [this.ret.formalName],
      retirementDate: [new Date(), Validators.required],
      expirationDate: [this.ret.expirationDate, Validators.required],
      customerAddress: AddressComponent.buildForm(
        this.ret.customerAddress.address,
        this.fb,
        true
      ),
      chapter: [this.ret.chapter, this.isInternational ? [] : Validators.required],
      attest: [false, Validators.required]

    });
  }

  onAddress_StateChanged(s: string) {


    //if chapter already exists then ..do nothing
    if (this.chapters.find(a => a.code == s) != null) return;

    //get the state chapter record
    let newChapter = getChapterInfo_From_AccountProducts(s, this.memberAppDataService.memberAppData.AccountProducts);

    //remove the previous state chapter
    this.chapters = this.chapters.filter(a => a.code != this.ret.chapter);

    //add teh new chapter
    if (newChapter != null) {

      this.ret.chapter = s;
      newChapter.isPrimary = true;
      this.chapters.push(newChapter);
      this.chapters = this.sortObjectArray(this.chapters);
    }

  }

  onAddress_CountryChanged(c: string) {
    this.isInternational = (c != "US");

  }

  save() {

    this.globalDomOpsService.showwait();
    this.ret.retirementDate = moment(this.retirementForm.get('retirementDate').value).format('MM/DD/YYYY');

    this.ret.chapter = getChapterInfo_From_AccountProducts(this.chapter.value, this.memberAppDataService.memberAppData.AccountProducts);

    this.ret.customerAddress = this.retirementForm.get('customerAddress').value;


    let ef: FormGroup | any = this.retirementForm;
    let payload = {
      contactid: this.ssoService.contactid,
      address_line1: this.customerAddress.get('address1').value,
      address_line2: this.customerAddress.get('address2').value,
      address_line3: this.customerAddress.get('address3').value,
      city: this.customerAddress.get('city').value,
      state: this.customerAddress.get('state').value,
      zip: this.customerAddress.get('zip').value,
      country: this.customerAddress.get('country').value,
      email: '',
      phone: ''
    }


    this.retiredService.postContactInfoData(payload).subscribe(() => {
      //send the email to mcc
      this.sentRetirementInfoEmailToMCC(payload);
      this.formSubmitted = true;
      this.globalDomOpsService.hidewait();
    })





  }

  public sentRetirementInfoEmailToMCC(payload) {

    let title = "ACEP Guide and Retired Application";
    let chapterName = getChapterInfo_From_AccountProducts(this.chapter.value, this.memberAppDataService.memberAppData.AccountProducts)?.name;

    let htmlManual = "";

    htmlManual += `<h3>${title}</h3><br/>`;
    htmlManual +=
      "<b>Please find below the details of the request:</b><br />";
    htmlManual += "<table>";
    htmlManual += `<tr><td>ACEP ID:</td><td>${this.ssoService.acepid}</td><tr>`;
    htmlManual += `<tr><td>Member's Full Name and Title:</td><td>${this.ret.formalName}</td><tr>`;
    htmlManual += `<tr><td>Current Date:</td><td>${moment().format('MM/DD/YYYY')}</td><tr>`;
    htmlManual += `<tr><td>Date of Retirement:</td><td>${this.ret.retirementDate}</td><tr>`;
    htmlManual += `<tr><td>Membership Expiration Date:</td><td>${this.ret.expirationDate}</td><tr>`;
    //htmlManual += `<tr><td>Address Line 1:</td><td>${payload.address_line1}</td><tr>`;
    htmlManual += `<tr><td>Address 1:</td><td>${payload.address_line2}</td><tr>`;
    htmlManual += `<tr><td>Address 2:</td><td>${payload.address_line3}</td><tr>`;
    htmlManual += `<tr><td>City:</td><td>${payload.city}</td><tr>`;
    htmlManual += `<tr><td>State/Province:</td><td>${payload.state}</td><tr>`;
    htmlManual += `<tr><td>Country:</td><td>${payload.country}</td><tr>`;
    htmlManual += `<tr><td>Postal Code:</td><td>${payload.zip}</td><tr>`;
    htmlManual += `<tr><td>Chapter:</td><td>${chapterName}</td><tr>`;
    htmlManual += `<tr><td>Attestation:</td><td> I have reviewed the requirements and attest that I meet the qualifications for retired status in the American College of Emergency Physicians.</td><tr>`;

    htmlManual += "</table>";

    htmlManual = btoa(htmlManual);

    //Email
    let email_from = "donotreply@acep.org";
    let email_to = this.globalDataOpsService.isTestEnvironment() ? "websupport@acep.org" : "membership@acep.org";
    let email_cc = ""; // this.globalDataOpsService.isTestEnvironment() ? "" : "websupport@acep.org";

    let subject = `${title}` + " - " + this.ssoService.acepid;
    this.globalDataOpsService
      .SendEmail(
        this.ssoService.contactid,
        email_from,
        email_to,
        email_cc,
        subject,
        htmlManual
      )
      .subscribe(() => {
        this.loggerService.logInfo("Email Sent to MCC");
        setTimeout(function () {
          window.location.href = 'https://www.acep.org/acep-membership/retired-membership'
        }, 6000);
      });

  }




  sortObjectArray(objArray: any): Array<any> {
    objArray = objArray.sort((a, b) => (a.name > b.name) ? 1 : -1)
    return objArray;
  }

}
